export default __webpack_public_path__ + "static/media/youtube.daf622d5.svg";